import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccessibilityClickableDiv, AccessibilityHidden, AccessibilityPopup } from '@skillz/accessibility';
import { login } from '../../../../store/auth-actions';
import { deviceTypes } from '../../../../enums/deviceTypes';
import Tooltip from '../../../ui/tooltip/Tooltip';
import UserDetails from './userDetails/UserDetails';
import useClickOutside from '../../../../hooks/useClickOutside';
import BottomPopup from '../../../ui/bottomPopup/BottomPopup';
import Icon from '../../../ui/icons/Icon';
import iconsList from "../../../ui/icons/iconsList";
import classes from './UserProfile.module.css';

const UserProfile = () => {

    const userDetailsRef = useRef()
    const [openUserDetails, setOpenUserDetails] = useState()
    const { deviceType } = useSelector(state => state.responsive);
    const { texts } = useSelector(state => state.translate);
    const isAuth = useSelector(state => state.auth.isAuth);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();

    useClickOutside(userDetailsRef, () => {
        setOpenUserDetails(false)
    });

    const closePopup = () => {
        setOpenUserDetails(false);
    }

    return (
        <div className={classes.UserProfile} ref={userDetailsRef}>
            {isAuth ?
                <Tooltip text={texts.privateArea} showTooltip={true}>
                    <AccessibilityClickableDiv className={classes.UserDetails} onClick={setOpenUserDetails} accessibilityDescription={`${texts.myProfile} ${user?.given_name} ${user?.family_name}`} >
                        <Icon size='34px' className={classes.SettingstIcon} name={iconsList.settings} />
                    </AccessibilityClickableDiv>
                </Tooltip>
                :
                <Icon className={classes.UserIcon} size="36px" name={iconsList.profile} onClick={() => dispatch(login())} />
            }

            {openUserDetails && <>
                {deviceType !== deviceTypes.mobile ?
                    <AccessibilityPopup accessibilityDescription={texts.myProfile} close={closePopup}>
                        <div>
                            <UserDetails close={closePopup} />
                        </div>
                    </AccessibilityPopup>
                    :
                    <BottomPopup onClose={closePopup} title={texts.myProfile} icon={<Icon name={iconsList.user} size="25px" />}>
                        <UserDetails close={closePopup} />
                    </BottomPopup>
                }
            </>}
        </div>
    )
}
export default UserProfile;